// extracted by mini-css-extract-plugin
export default {"footerText":"SureFooter_footerText__B6TXB","sureFooter":"SureFooter_sureFooter__A7gaH","footerPadding":"SureFooter_footerPadding__Exox0","navItem":"SureFooter_navItem__cjAgz"};